<script setup>
import {ref} from "vue";
import {useStore} from "@/store";
import GlobusTextArea from "@/components/UI/GlobusInput/GlobusTextArea.vue";
import NerResult from "@/components/NerResult.vue";

const textAreaRef = ref(null);

const prompt = ref("");
const text = ref("");
const result = ref({
  persons: [],
  organisations: [],
  locations: [],
  summary: ""
});

const store = useStore();

const isClickedSend = ref(false);

// Запрос выделения объектов
const createNer = async (newText) => {
  if (isClickedSend.value) return false;
  isClickedSend.value = true;
  const response = await store.createNer(newText, prompt.value);

  text.value = highlightText(newText, response);
  result.value = response;

  isClickedSend.value = false;
};

// Очистка промпта
const clearPrompt = () => {
  prompt.value = "";
};

// Очистка поля ввода
const clearTextArea = () => {
  text.value = "";
};

// Ховер по категориям
const hoverType = ref(null);

// Подсветка выделенных объектов
const highlightText = (text, keywordsMap) => {
  // CSS-классы для каждой категории
  const classByCategory = {
    persons: "person-highlight",
    locations: "location-highlight",
    organisations: "organisation-highlight"
  };

  // Собираем карту {слово→категория} и массив всех слов
  const wordToCategory = {};
  const words = [];

  for (const [category, list] of Object.entries(keywordsMap)) {
    for (const w of list) {
      if (typeof w === "object") {
        const low = w.name.toLowerCase();
        if (!wordToCategory[low]) {
          wordToCategory[low] = category;
          words.push(w.name);
        }
      } else {
        const low = w.toLowerCase();
        if (!wordToCategory[low]) {
          wordToCategory[low] = category;
          words.push(w);
        }
      }

    }
  }

  if (words.length === 0) return text;

  const esc = s => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  words.sort((a, b) => b.length - a.length);
  const alternation = words.map(esc).join("|");

  const pattern = new RegExp(`(?<!\\p{L})(?:${alternation})(?!\\p{L})`, "giu");

  // Одна замена на всё
  return text.replace(pattern, match => {
    const cat = wordToCategory[match.toLowerCase()];
    const cls = classByCategory[cat] || "highlight";
    return `<span class="${cls}">${match}</span>`;
  });
};
</script>

<template>
  <div class="main-wrapper">
    <div class="form-wrapper">
      <GlobusTextArea
        v-model="prompt"
        label="Промпт"
        placeholder="Вставьте текст промпта"
        :is-clicked="isClickedSend"
        :hover-type="hoverType"
        @clear-text-area="clearPrompt"
      />
      <GlobusTextArea
        ref="textAreaRef"
        v-model="text"
        label="Текст для проверки"
        placeholder="Вставьте текст для проверки работы нейросети"
        :is-clicked="isClickedSend"
        :hover-type="hoverType"
        @action="createNer"
        @clear-text-area="clearTextArea"
      />
      <ButtonAccentPrimary
        size="large"
        class="form-wrapper__button form-wrapper__button--accent"
        :is-clicked="isClickedSend"
        @click="textAreaRef.onAction()"
      >
        Выделить объекты
      </ButtonAccentPrimary>
    </div>

    <NerResult
      :hover-type="hoverType"
      :result="result"
      @change-hover-type="val => hoverType = val"
    />
  </div>
</template>

<style lang="scss">
@import '@/assets/style/vars.scss';

.main-wrapper {
  min-height: 0;
  margin-top: 15px;
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  height: 100%;
  overflow: hidden;
}

.form-wrapper {
  display: grid;
  grid-template-rows: minmax(0, 1fr) minmax(0, 1fr) 40px;
  overflow: hidden;

  &__button {
    margin-left: auto !important;
    width: 180px;

    &--accent {
      background: $button-active-color !important;
    }
  }
}

</style>